import { connect } from "react-redux";
import Router from "next/router";

import { Row, Col, Space, Card } from "antd";

import { getCategories, fetchCategory } from "~/redux/actions/app";
import { fetchJobsChannelPostList } from "~/redux/actions/post";

import SiteLayout from "~/components/layout/SiteLayout";
import PostList from "~/components/post/PostList";
import SiderPostJob from "~/components/sider/SiderPostJob";
import CategoryTagNavs from "~/components/header/CategoryTagNavs";
import RecruitmentTypeFilter from "~/components/header/RecruitmentTypeFilter";
import SiderPrimary from "~/components/sider/SiderPrimary";
import SiderJobsSummary from "~/components/sider/SiderJobsSummary";
import TalentIncludedCheckbox from "~/components/forms/TalentIncludedCheckbox";
import { decodeTags } from "~/utils/post";
import { getCookie } from "~/utils/cookie";
import {
  checkVerification,
  buildFullUrl,
  buildVerificationRedirect,
  clearVerificationCookieInResponse,
} from "~/utils/verification";

const JobsChannelPage = (props) => {
  const {
    category,
    categories,
    postList,
    tags,
    sort,
    page,
    shouldShowCheckbox,
  } = props;

  const pageSider = (
    <div>
      <SiderJobsSummary />
      <SiderPostJob />
      <SiderPrimary />
    </div>
  );

  const containerHeader = (
    <div className="container-header">
      <Row>
        <Col
          xs={24}
          sm={24}
          md={0}
        ></Col>
      </Row>
      <Card>
        <Space
          direction="vertical"
          size={12}
          style={{ display: "flex" }}
        >
          <Row
            align="top"
            justify="space-between"
            gutter={[16, 12]}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              <RecruitmentTypeFilter
                preserveParams={["talent_included", "tags"]}
              />
            </Col>
          </Row>
          <Row
            align="top"
            justify="space-between"
            gutter={[16, 12]}
          >
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              <CategoryTagNavs
                category={category}
                preserveParams={["talent_included", "recruitment_type"]}
              />
            </Col>
            {/* {shouldShowCheckbox && (
              <Col
                xs={24}
                sm={24}
                md={6}
                lg={4}
                xl={4}
                className="talent-checkbox-col"
              >
                <TalentIncludedCheckbox />
              </Col>
            )} */}
          </Row>
        </Space>
      </Card>
    </div>
  );

  return (
    <>
      <SiteLayout
        pageSider={pageSider}
        containerHeader={containerHeader}
      >
        <PostList
          postList={postList}
          sort={props.sort}
        />
      </SiteLayout>
      <style
        jsx
        global
      >{`
        .talent-checkbox-col {
          display: flex;
          justify-content: flex-start;
        }

        @media (min-width: 768px) {
          .talent-checkbox-col {
            justify-content: flex-end;
          }
        }
      `}</style>
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  categories: state.app.categories,
});

const mapDispatchToProps = () => ({});

JobsChannelPage.requireUser = () => false;

JobsChannelPage.getInitialProps = async (ctx) => {
  const { query, req } = ctx;

  // 暂时停用 cloudflare turnstile 验证，因为在中国访问 cloudflare 有问题
  // TODO: 替换为国内适配的方案
  // // 检查验证状态
  // const { isValid, token } = await checkVerification(req);

  // // 如果验证失败或没有 token，重定向到验证页面
  // if (!isValid) {
  //   // 构建完整的当前页面 URL（包含所有 query 参数）
  //   const currentUrl = buildFullUrl("/jobs-channel", query);
  //   const verificationUrl = buildVerificationRedirect(currentUrl);

  //   // 服务端重定向
  //   if (ctx.res) {
  //     // 清除失效的 cookie（如果存在）
  //     if (token) {
  //       clearVerificationCookieInResponse(ctx.res);
  //     }
  //     ctx.res.writeHead(302, { Location: verificationUrl });
  //     ctx.res.end();
  //   } else {
  //     // 客户端重定向
  //     Router.replace(verificationUrl);
  //   }
  //   return {};
  // }

  // Token 有效，继续获取数据
  const state = ctx.store.getState();

  // 加载首页的所有版块
  if (!state.app.categories.length) {
    await ctx.store.dispatch(getCategories());
  }
  const categories = ctx.store.getState().app.categories.filter((x) => !x.paid);
  const jobsChannel = categories.find((x) => x.code === "jobs_channel");
  const category = await fetchCategory(jobsChannel.id);

  // 加载首页的帖子列表
  const tags = decodeTags(query.tags);
  const cookieSort = getCookie("sort", req);
  const sort = query.sort || cookieSort;
  const page = parseInt(query.page) || 1;

  // Find the jobs_type tag group by its code
  const jobsTypeGroup = category.tag_groups.find(
    (group) => group.code === "jobs_type"
  );

  // Get the index of the jobs_type group in the tag_groups array
  const jobsTypeIndex = category.tag_groups.findIndex(
    (group) => group.code === "jobs_type"
  );

  // Get the selected tag ID for the jobs_type group
  const selectedJobsTypeTagId =
    jobsTypeIndex !== -1 ? tags[jobsTypeIndex] : null;

  // Get the "Full-time Remote" tag (first tag in the jobs_type group)
  const fullTimeRemoteTag =
    jobsTypeGroup && jobsTypeGroup.tags && jobsTypeGroup.tags.length > 0
      ? jobsTypeGroup.tags[0]
      : null;

  // Check if we should show the checkbox (All or Full-time Remote selected)
  const shouldShowCheckbox =
    !selectedJobsTypeTagId ||
    (fullTimeRemoteTag && selectedJobsTypeTagId === fullTimeRemoteTag.id);

  // Build the params object
  const params = {
    sort,
    page,
    tags,
    category: query.category,
  };

  // Add recruitment_type if specified
  if (query.recruitment_type) {
    params.recruitment_type = query.recruitment_type;
  }

  // Only add talent_included if checkbox should be shown and it's not explicitly set to false
  if (shouldShowCheckbox && query.talent_included !== "false") {
    params.talent_included = true;
  }

  const postList = await fetchJobsChannelPostList(params);

  return {
    category,
    categories,
    postList,
    tags,
    sort,
    page,
    shouldShowCheckbox,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobsChannelPage);
